export default function GS_Color_Scale_Formatting() {
  return (
    <div className="p-4">
      <h1>GS Color Scale Formatting</h1>
    </div>
  );
}
